<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="corporateCustomers"
      :pagination.sync="pagination"
      :loading="loading"
      class="elevation-1"
      :hide-default-footer="true"
    >
      <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
      <template v-slot:item="props">
        <tr v-on:click.stop="goToCorporateCustomer(props.item.id)">
          <td style="width:25%;">{{props.item.name}}</td>
          <td style="width:15%;">
            <p
              v-if="props.item.accounting_reference_number != null"
            >{{ props.item.accounting_reference_number }}</p>
          </td>
          <td style="width:20%;">
            <a
              v-on:click.stop="doNothing()"
              :href="'tel:' + formatNumber(props.item.contact_number)"
            >{{ props.item.contact_number }}</a>
          </td>
          <td style="width:20%;">
            <a
              v-on:click.stop="doNothing()"
              :href="'mailto:' + props.item.email"
            >{{ props.item.email }}</a>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "corporate_customer_list",
  props: {
    corporateCustomers: Array,
    paginationProp: Object,
    loading: Boolean
  },
  mounted: function() {
    console.log("Replace Start:" + replaceStart);
  },
  data: function() {
    return {
      pagination: this.paginationProp,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Accounting Reference No.",
          align: "left",
          sortable: false,
          value: "accounting_reference"
        },
        {
          text: "Contact Number",
          align: "left",
          sortable: false,
          value: "contact_number"
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email"
        }
      ]
    };
  },
  methods: {
    goToCorporateCustomer: function(id) {
      this.$router.push(`/corporateCustomer/view/${id}`);
    },
    doNothing: function() {},
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
